import styled from 'styled-components';
import { FlexDiv } from '../../../../common/Styles';

export const ProductVideosContainer = styled.div(
	({ theme: { down, breakpoints } }) => `
		display: flex;
		justify-content: space-between;
		${down(breakpoints.md)} {
			overflow: scroll;
			padding-left: 16px;
		}
	`
);

export const PlayBtn = styled.button(
	({ theme: { down, breakpoints } }) => `
		width: 42px;
		height: 42px;
		background: #ffffff;
		margin-bottom: 20px;
		&:focus {
			outline: none;
		}
		border: none;
		border-radius: 100%;
		cursor: pointer;
		position: absolute;
		bottom: 30%;
		left: 50%;
		transform: translate(-50%, -50%);
		&::after {
			content: "";
			display: inline-block;
			position: relative;
			top: 1px;
			left: 3px;
			border-style: solid;
			border-width: 10px 0 10px 16px;
			border-color: transparent transparent transparent #ff664b;
		}
		`
);

export const ProductVideoLeftGrid = styled.div(
	({ theme: { down, breakpoints } }) => `
		position: relative;
		&:first-child{
			width: 49.5%;
		}
		img{
			border-radius: 2px;
		}
		${down(breakpoints.md)} {
			&:first-child{
				min-width: 90%;
				margin-right: 10px;
				border-radius: 6px;
			}
			img{
				border-radius: 6px;
			}
			}
			button{
				bottom: 37%;
		}
	`
);

export const ProductVideoRightGrid = styled.div(
	({ theme: { down, breakpoints } }) => `
		width: 49.3%;

		${down(breakpoints.md)} {
			min-width: 90%;
			display: flex;
			flex-direction: column;
			img{
				border-radius: 6px;
			}
		}
`
);

export const ProductVideoItem = styled.div`
	min-width: 100%;
	margin-bottom: 5px;
	position: relative;
	&:hover ${PlayBtn} {
		background: #ff664b;
		transition: background 500ms linear;
		&::after {
			border-color: transparent transparent transparent #ffffff;
			transition: border-color 500ms linear;
		}
	}
	>img {
		width : ${(props) => props.firstVideo ? '100%' : '289px'};
	}
`;

export const ProductVideoOverlay = styled.div(
	({ theme: { down, breakpoints } }) => `
		background: rgba(7, 18, 31, 0.6);
		border-radius: 2px;
		height: 100%;
		width: 100%;
		position: absolute;
		${down(breakpoints.md)} {
			border-radius: 6px;
		}
	`
);

export const ProductVideoContent = styled.div(
	({ theme: { down, breakpoints } }) => `
		position: absolute;
		bottom: 0;
		padding: 30px 30px 16px;
		${down(breakpoints.md)} {
			padding: 16px;
		}
	`
);

export const CloseIcon = styled.span`
	position:absolute;
	top: 50px;
	right: -30px;
	width: 50px;
	height: 50px;
	cursor: pointer;
	&:before, &:after {
		position: absolute;
		content: ' ';
		height: 18px;
		width: 2px;
		background-color: #fff;
	}
	&:before {
		transform: rotate(45deg);
	}
	&:after {
		transform: rotate(-45deg);
	}
	&:hover {
		cursor: pointer;
	}
`;

export const SliderOuterWrap = styled.div`
	>div > div > div >div {
		&.slick-slide{
			padding-right: 10px;
		}
	}
`;

export const VideoWrapper = styled(FlexDiv)`
	margin-top : ${(props) => props.top_M ? props.top_M : 'auto'};
`;
